import { initFormValidation } from '../../Scripts/validation';

const showForgotPasswordPrompt = () => {
  const forgotPasswordPrompt = document.getElementById('forgot-password-prompt');
  if (!forgotPasswordPrompt) return;
  forgotPasswordPrompt.classList.remove('hidden');
};

const registerForgotPassword = () => {
  const forgotPasswordButton = document.getElementById('forgot-password-button');
  if (!forgotPasswordButton) return;
  forgotPasswordButton.addEventListener('click', showForgotPasswordPrompt);
};

// Main
(function () {
  initFormValidation(document.getElementById('js-sign-in') as HTMLFormElement);
  registerForgotPassword();
})();
